module.exports = __webpack_public_path__ + "static/media/netsuit.824a21ec.png";